module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-edit"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('div', [_c('transition', {
    attrs: {
      "name": "notifyFade"
    }
  }, [(_vm.notify !== null) ? _c('div', {
    staticClass: "notify-message-parent"
  }, [_c('div', {
    staticClass: "notify-message"
  }, [_c('div', {
    staticClass: "alert alert-dismissible",
    class: {
      'alert-success': _vm.notify.success, 'alert-danger': _vm.notify.danger, 'alert-warning': _vm.notify.warning
    }
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#",
      "data-dismiss": "alert",
      "aria-label": "close",
      "title": "close"
    }
  }, [_vm._v("×")]), _vm._l((_vm.notify.errors), function(error) {
    return _c('p', {
      staticClass: "notify-msg"
    }, [_vm._v(_vm._s(error))])
  })], 2)])]) : _vm._e()])], 1), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_vm._v(_vm._s(_vm.$t('User List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('User Edit')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    on: {
      "click": _vm.goUserLists
    }
  }, [_vm._v(_vm._s(_vm.$t('user_list.employee')))])])])])]), (_vm.user != null) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('User Edit')))])]), _c('div', {
    staticClass: "col-sm-3"
  })])]) : _vm._e(), (_vm.loading) ? _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(0)]) : _c('div', [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("社員画像")]), (_vm.userImage != null) ? _c('div', {
    staticClass: "col-sm-5 text-center"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('img', {
    staticClass: "img-rounded",
    staticStyle: {
      "width": "auto",
      "max-height": "200px"
    },
    attrs: {
      "src": _vm.userImage
    },
    on: {
      "click": function($event) {
        _vm.onClickImageModalShow()
      }
    }
  })])]) : _vm._e()]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#image_upload_modal"
    }
  }, [_c('span', [_vm._v("画像登録")])]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadError),
      expression: "uploadError"
    }],
    staticClass: "validation-msg"
  }, [_vm._v("画像のアップロードに失敗しています")])])]), _c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("氏名")]), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.user_name
    },
    attrs: {
      "type": "text",
      "placeholder": "氏"
    },
    domProps: {
      "value": _vm._s(_vm.user.user_name)
    },
    on: {
      "change": _vm.kanaSupport,
      "keyup": _vm.half,
      "touchend": _vm.half,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.user_name),
      expression: "!validation.user_name"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])]), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_firstname),
      expression: "user.user_firstname"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.user_firstname
    },
    attrs: {
      "type": "text",
      "placeholder": "名"
    },
    domProps: {
      "value": _vm._s(_vm.user.user_firstname)
    },
    on: {
      "change": _vm.kanaFirstSupport,
      "keyup": _vm.half,
      "touchend": _vm.half,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_firstname = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.user_firstname),
      expression: "!validation.user_firstname"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("しめい")]), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name_furigana),
      expression: "user.user_name_furigana"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.user_name_furigana
    },
    attrs: {
      "type": "text",
      "placeholder": "氏"
    },
    domProps: {
      "value": _vm._s(_vm.user.user_name_furigana)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name_furigana = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.user_name_furigana),
      expression: "!validation.user_name_furigana"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.invalid_furigana')))])]), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_firstname_furigana),
      expression: "user.user_firstname_furigana"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.user_firstname_furigana
    },
    attrs: {
      "type": "text",
      "placeholder": "名"
    },
    domProps: {
      "value": _vm._s(_vm.user.user_firstname_furigana)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_firstname_furigana = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.user_firstname_furigana),
      expression: "!validation.user_firstname_furigana"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.invalid_furigana')))])])]), _c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("社員番号")]), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.code),
      expression: "user.code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "社員番号"
    },
    domProps: {
      "value": _vm._s(_vm.user.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.code = $event.target.value
      }
    }
  })])]), _c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("入社経緯")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.join_id),
      expression: "user.join_id"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.join_id
    },
    on: {
      "change": function($event) {
        _vm.user.join_id = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option'), _vm._l((_vm.joins), function(join) {
    return _c('option', {
      domProps: {
        "value": join.id
      }
    }, [_vm._v(_vm._s(join.attributes['join-class']))])
  })], 2), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.join_id),
      expression: "!validation.join_id"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("生年月日")]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('el-date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_birthday),
      expression: "user.user_birthday"
    }],
    class: {
      required: !_vm.validation.user_birthday
    },
    attrs: {
      "placeholder": "yyyy-mm-dd"
    },
    domProps: {
      "value": (_vm.user.user_birthday)
    },
    on: {
      "change": _vm.calAge,
      "input": function($event) {
        _vm.user.user_birthday = $event
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.user_birthday),
      expression: "!validation.user_birthday"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])], 1), _c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("入社日")]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('el-date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_joinday),
      expression: "user.user_joinday"
    }],
    class: {
      required: !_vm.validation.user_joinday
    },
    attrs: {
      "placeholder": "yyyy-mm-dd"
    },
    domProps: {
      "value": (_vm.user.user_joinday)
    },
    on: {
      "input": function($event) {
        _vm.user.user_joinday = $event
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.user_joinday),
      expression: "!validation.user_joinday"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])], 1)]), _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("年齢")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.age) + " 歳")])])]), _c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("性別")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_sex),
      expression: "user.user_sex"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.user.user_sex, "1")
    },
    on: {
      "click": function($event) {
        _vm.user.user_sex = "1"
      }
    }
  }), _c('span', [_vm._v("男性")])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_sex),
      expression: "user.user_sex"
    }],
    attrs: {
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.user.user_sex, "2")
    },
    on: {
      "click": function($event) {
        _vm.user.user_sex = "2"
      }
    }
  }), _c('span', [_vm._v("女性")])]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.user_sex),
      expression: "!validation.user_sex"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("住所")]), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("〒")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_post_no),
      expression: "user.user_post_no"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.user_post_no || _vm.required.user_post_no || _vm.required.user_post_no_format
    },
    attrs: {
      "type": "tel",
      "placeholder": "例)8380141",
      "maxlength": "10"
    },
    domProps: {
      "value": _vm._s(_vm.user.user_post_no)
    },
    on: {
      "change": _vm.onChangePostNo,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_post_no = $event.target.value
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.user_post_no),
      expression: "!validation.user_post_no"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.not_hyphen')))])]), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_address),
      expression: "user.user_address"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.user_address || _vm.required.user_address
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.user.user_address)
    },
    on: {
      "keyup": _vm.half,
      "touchend": _vm.half,
      "change": _vm.onChangeAddress,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_address = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.user_address),
      expression: "!validation.user_address"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("携帯番号")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_mobile),
      expression: "user.user_mobile"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.user_mobile
    },
    attrs: {
      "type": "tel",
      "placeholder": "例)090-1234-5678",
      "maxlength": "13"
    },
    domProps: {
      "value": _vm._s(_vm.user.user_mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_mobile = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.user_mobile),
      expression: "!validation.user_mobile"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.fomat_tel')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("電話番号")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_tel),
      expression: "user.user_tel"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.user_tel
    },
    attrs: {
      "type": "tel",
      "placeholder": "例)092-123-4567",
      "maxlength": "13"
    },
    domProps: {
      "value": _vm._s(_vm.user.user_tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_tel = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.user_tel),
      expression: "!validation.user_tel"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.fomat_tel')))])])]), _c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("メールアドレス")]), _c('div', {
    staticClass: "form-inline col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.user_email
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.user.email)
    },
    on: {
      "keyup": _vm.half,
      "touchend": _vm.half,
      "change": _vm.half,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "form-inline"
  }, [_vm._v(" @ ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_domain_content),
      expression: "user.user_domain_content"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.domain_content
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.user.user_domain_content)
    },
    on: {
      "keyup": _vm.half,
      "touchend": _vm.half,
      "change": _vm.half,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_domain_content = $event.target.value
      }
    }
  }), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_domain_content_work),
      expression: "user_domain_content_work"
    }],
    staticClass: "combo",
    on: {
      "change": [function($event) {
        _vm.user_domain_content_work = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, _vm.selectedDomain]
    }
  }, _vm._l((_vm.domains), function(domain) {
    return _c('option', {
      domProps: {
        "value": domain.attributes['domain-content']
      }
    }, [_vm._v(_vm._s(domain.attributes['domain-content']))])
  })), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.email_domain),
      expression: "!validation.email_domain"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('hr'), _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("業務内容詳細")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "form-control-static",
    domProps: {
      "innerHTML": _vm._s(_vm.business_content)
    }
  })])]), _c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("備考")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_memo),
      expression: "user.user_memo"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "255",
      "rows": "6"
    },
    domProps: {
      "value": _vm._s(_vm.user.user_memo)
    },
    on: {
      "keyup": _vm.userMemoCounter,
      "touchend": _vm.userMemoCounter,
      "change": _vm.userMemoCounter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_memo = $event.target.value
      }
    }
  }), _c('p', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.userMemoCount) + "/255")])])]), _c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("個人メモ")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_business_type_remarks),
      expression: "user.user_business_type_remarks"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "255",
      "rows": "6"
    },
    domProps: {
      "value": _vm._s(_vm.user.user_business_type_remarks)
    },
    on: {
      "keyup": _vm.remarkCounter,
      "touchend": _vm.remarkCounter,
      "change": _vm.remarkCounter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_business_type_remarks = $event.target.value
      }
    }
  }), _c('p', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.remarkCount) + "/255")])])]), _c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("遊技台システム権限")]), _c('div', {
    staticClass: "form-inline col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.machine_order_type),
      expression: "user.machine_order_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.user.machine_order_type = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.roles), function(role) {
    return _c('option', {
      domProps: {
        "value": role.value
      }
    }, [_vm._v(_vm._s(role.label))])
  }))])]), (_vm.user.machine_order_type === 'area_master') ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("担当店舗")]), _c('div', {
    staticClass: "form-inline col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.shops), function(shop, index) {
    return _c('div', {
      staticClass: "col-sm-4"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.shop_ids),
        expression: "user.shop_ids"
      }],
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        "type": "checkbox",
        "id": 'shop_' + index
      },
      domProps: {
        "value": shop.id,
        "checked": Array.isArray(_vm.user.shop_ids) ? _vm._i(_vm.user.shop_ids, shop.id) > -1 : (_vm.user.shop_ids)
      },
      on: {
        "click": function($event) {
          var $$a = _vm.user.shop_ids,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = shop.id,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.user.shop_ids = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.user.shop_ids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.user.shop_ids = $$c
          }
        }
      }
    }), _c('label', {
      attrs: {
        "for": 'shop_' + index
      }
    }, [_vm._v(_vm._s(shop.attributes['shop-name']))])])
  }))])]) : _vm._e(), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.validation.not_input
    },
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": _vm.onClickSave
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v("保存")])]), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.onClickCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v("キャンセル")])])])])])]), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "imageModalButton",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#imageModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "imageModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modalcenter"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _c('div', {
    staticClass: "modal-img_footer text-center"
  }, [_c('p', {
    attrs: {
      "id": "imageModalText"
    }
  }), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Close')))])])])])]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "image_upload_modal",
      "role": "dialog",
      "aria-labelledby": "imageUploadModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(2), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    attrs: {
      "id": "image_upload_section"
    }
  }, [_c('div', {
    staticClass: "drop-uploader text-center",
    attrs: {
      "id": "drop"
    },
    on: {
      "dragover": _vm.onDragOver,
      "drop": _vm.onDrop
    }
  }, [_c('p', [_vm._v("ここに画像をドラッグアンドドロップしてください。")]), _c('i', {
    staticClass: "fa fa-upload"
  })]), _c('input', {
    attrs: {
      "type": "file",
      "multiple": "multiple"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]), (_vm.uploadSuccess && _vm.upFlg) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Image Upload Successful')))])]) : _vm._e(), (_vm.uploadError && _vm.upFlg) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Image Upload Error')))])]) : _vm._e()]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Close')))])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/loading.gif")
    }
  }), _c('p', [_vm._v("loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "id": "imageModalImg",
      "src": "",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "imageUploadModalLabel"
    }
  }, [_vm._v("画像登録")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-53f9a86a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/user-edit.pug
// module id = 821
// module chunks = 1